import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ClickAwayListener, Collapse, Divider, IconButton, InputBase, Paper, } from "@mui/material";
import { Close, Magnify } from "mdi-material-ui";
import { useCallback, useEffect, useRef, useState } from "react";
import { ListHighlight } from "./ListHighlight.js";
export function useSearch() {
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState("");
    return { open, setOpen, value, setValue };
}
export function Search({ options, renderItem, getKey, placeholder, onSelect, onClose, children, open, setOpen, value, setValue, noOptions, }) {
    const inputRef = useRef(null);
    const handleClose = useCallback(() => {
        if (open) {
            onClose?.();
            setOpen(false);
        }
    }, [open, onClose, setOpen]);
    useEffect(() => {
        function handleKeyDown(event) {
            if (event.key === "Escape") {
                handleClose();
            }
            else if (event.key === "k" && (event.metaKey || event.ctrlKey)) {
                event.preventDefault();
                setOpen((open) => !open);
            }
        }
        addEventListener("keydown", handleKeyDown);
        return () => removeEventListener("keydown", handleKeyDown);
    }, [handleClose, setOpen]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Unstable dependencies
    useEffect(() => {
        if (open) {
            inputRef.current?.focus();
        }
        else {
            setValue("");
            inputRef.current?.blur();
        }
    }, [open]);
    return (_jsx(ClickAwayListener, { onClickAway: handleClose, children: _jsxs(Paper, { elevation: open ? 4 : 1, children: [_jsxs(Box, { component: "label", sx: {
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        pr: 1,
                    }, children: [_jsx(Magnify, { sx: { mx: 1.5 } }), _jsx(InputBase, { inputProps: {
                                id: "search-box",
                                autoComplete: "off",
                            }, inputRef: inputRef, value: value, sx: { py: 0.5, flex: 1 }, placeholder: placeholder, onFocus: () => setOpen(true), onChange: (event) => setValue(event.currentTarget.value), onKeyDown: (event) => {
                                if (event.key === "Escape") {
                                    handleClose();
                                }
                            } }), value && (_jsx(IconButton, { size: "small", onClick: (event) => {
                                event.preventDefault();
                                handleClose();
                            }, children: _jsx(Close, { fontSize: "small" }) })), children] }), open && _jsx(Divider, {}), _jsx(Collapse, { in: open, timeout: 200, sx: { maxHeight: 720, overflow: "auto" }, children: _jsx(ListHighlight, { options: options || [], getKey: getKey, onSelect: onSelect, renderItem: renderItem, disabled: !open }) }), options?.length === 0 && noOptions] }) }));
}
//# sourceMappingURL=Search.js.map